class PanoEvent {
  /**
   * 渲染事件
   */
  static RENDER = 'RENDER'
  /**
   * 加载中
   */
  static LOAD_PROGRESS = 'LOAD_PROGRESS'
  /**
   * 加载完成
   */
  static LOAD_COMPLETE = 'LOAD_COMPLETE'
  /**
   * 加载出错
   */
  static LOAD_ERROR = 'LOAD_ERROR'
  /**
   * 标记选中
   */
  static MARKER_SELECT = 'MARKER_SELECT'

  /**
   * 场景切换
   */
  static SCENE_CHANGE = 'SCENE_CHANGE'
  /**
   * 场景切换
   */
  static SCENE_CHANGE_START = 'SCENE_CHANGE_START'
  /**
   * 场景切换
   */
  static SCENE_CHANGE_END = 'SCENE_CHANGE_END'
}
export { PanoEvent }



// WEBPACK FOOTER //
// ./src/webgl/events/PanoEvents.js